(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueDeleteController',TabActionsQueueDeleteController);

    TabActionsQueueDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabActionsQueue'];

    function TabActionsQueueDeleteController($uibModalInstance, entity, TabActionsQueue) {
        var vm = this;
        vm.tabActionsQueue = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabActionsQueue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
